

import 'vue-snotify/styles/material.css'
import Snotify from 'vue-snotify'
import '@fortawesome/fontawesome-free/css/all.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import Acl from '@/plugins/acl'
import Masks from '@/configs/masks'
import ExtendRouter from '@/plugins/extendRouter'
import Dictionaries from '@/configs/dictionaries'
import Components from '@/configs/components'
import Libraries from '@/configs/libraries'
import Rules from '@/configs/rules'
import '@/assets/styles/global.styl'
import '@/assets/styles/box.css'
//import IdleVue from 'idle-vue'

export default {
    install: async (Vue, router, store) => {

/* ------------------------ plugin for notifications ------------------------ */
        Vue.use(Snotify)

/* --------------- Plugin for verify permissions and roles ACL -------------- */
        Vue.use(Acl, store)

/* ------------------------- Plugin for custom masks ------------------------ */
        Vue.use(Masks)

/* ---------------------- Extend parameters for router ---------------------- */
        Vue.use(ExtendRouter, router, store)

/* ----------------------- Diccionarios for global use ---------------------- */
        Vue.use(Dictionaries)

/* ----------------------- Register global components ----------------------- */
        Vue.use(Components)

/* --------------------------- Register libraries --------------------------- */
        Vue.use(Libraries)

/* ---------------------- Register rules for input form --------------------- */
        Vue.use(Rules)

/* -------------------------- For idle user waiting ------------------------- */
        /*Vue.use(IdleVue, {
            store: store,
            idleTime: 3600000
        })*/
    },
}
